import { authenticationService } from "./authentication";

type ThemeMode = "light" | "dark";

export const themeService = {
  async saveTheme(mode: ThemeMode): Promise<void> {
    const response = await authenticationService.makeAuthenticatedRequest(
      `${process.env.REACT_APP_API_URL}/user/theme`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ theme: mode }),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to save theme to backend");
    }
  },
};
